import { render } from "./AddCompanyInfo.vue?vue&type=template&id=67efb323&scoped=true"
import script from "./AddCompanyInfo.vue?vue&type=script&lang=js"
export * from "./AddCompanyInfo.vue?vue&type=script&lang=js"

import "./AddCompanyInfo.vue?vue&type=style&index=0&id=67efb323&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67efb323"]])

export default __exports__